<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">库存信息</h3>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="产品">
                  <el-select
                      style="width: 300px;"
                      v-model="query.product_id"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入关键词"
                      :remote-method="loadSelect"
                      :loading="selectIng"
                  >
                    <el-option
                        v-for="(item, i) in selectList"
                        :key="i"
                        :label="item.name + '【' + item.model_code + '】'"
                        :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="编码搜索">
                  <el-input v-model="query.keyword" placeholder="请输入编码搜索" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table :data="list" border v-loading="listLoading" style="width: 100%">
              <el-table-column prop="code" label="编码"></el-table-column>
              <el-table-column prop="mcu" label="MCU"></el-table-column>
              <el-table-column prop="name" label="产品名称"></el-table-column>
              <el-table-column prop="model_code" label="产品存货编码"></el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

export default {
  components: {},
  data() {
    return {
      auth: {},
      params: {},
      query: {
        product_id: 0,
        keyword: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
      selectIng: false,
      selectList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.product_id = parseInt(_this.query.product_id);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadSelect('').then(() => {
        _this.loadList();
      })
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 搜索
    loadSelect(keyword) {
      const _this = this;
      return new Promise((resolve) => {
        _this.selectIng = true;
        _this.$api.inventoryProductSelect({
          keyword: keyword,
          page: 1,
          size: 50,
        }).then(res => {
          _this.selectIng = false;
          _this.selectList = res.list;
          if (_this.selectList.length > 0 && _this.query.product_id === 0) {
            _this.query.product_id = _this.selectList[0].id;
          }
          resolve();
        }).catch(() => {
          _this.selectIng = false;
          resolve();
        })
      })
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.inventoryEntityList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.listLoading = true;
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>